import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Trans } from "react-i18next";
import { Stack } from "syf-component-library/ui/spacing";
import EnrollmentContent from "./EnrollmentContent";
import StatementsListContent from "./StatementsListContent";
import { DrawerHeader, HorizontalLine } from "./subComponents";
import products from "../../../../const/products";
import { useAccountSummary } from "../../../../const/syfApiQueries";
import { useStatementsContext } from "../../../../context/statementsContext";
import { useConfig } from "../../../../hooks/useConfig";
var StatementsModalContent = function () {
    var _a;
    var accountId = useStatementsContext().state.accountId;
    var config = useConfig();
    var accountSummary = useAccountSummary(accountId).data;
    var displayTitle = (_a = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product.displayName) !== null && _a !== void 0 ? _a : "";
    var isSetpayAccount = (accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product.type) === products.SET_PAY;
    return (_jsxs(_Fragment, { children: [_jsx(Stack, { size: "small" }), _jsx(DrawerHeader, { "data-cy": "statementsCardTitle", "data-testid": "header", title: displayTitle, subtitle: _jsx(Trans, { i18nKey: isSetpayAccount
                        ? "drawerHeader.subtitle.loan"
                        : "drawerHeader.subtitle.account", values: {
                        accountLast4: accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.accountInfo.accountLast4,
                    } }), alt: "", img: accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.card.cardArtURL, fallbackImage: "".concat(config.hosts.assets.origin, "/assets/cardArt/syf_generic_card.svg") }), _jsx(Stack, { size: "small" }), _jsx(HorizontalLine, {}), _jsx(EnrollmentContent, {}), _jsx(StatementsListContent, {})] }));
};
export default StatementsModalContent;
